var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { FormikProvider } from 'formik';
import { get } from 'lodash';
import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import * as yup from 'yup';
import { adjustPatientMedication, editPatientMedication } from '../Async/MedicationsSummaryAsync';
import { ButtonMode, ButtonVariant } from '../Components/Button';
import { StyledDialogActions } from '../Components/Dialog/StyledDialogActions';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { FormikStyledSelect } from '../Components/FormikFields/FormikStyledSelect';
import { AlertIconRound } from '../Components/Icons';
import { MaskedTextField } from '../Components/MaskedTextField';
import { isSingleSelectSingleValue } from '../Components/StyledSelect';
import { useForm } from '../Components/useForm/useForm';
import { displayError, displayMessage } from '../Config/ApplicationConfig';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { CdsStatus, ConsentDetailStatus, MedicationCourse, MedicationStatus, MedicationType, PaymentSchemeType, PoisonScheduleStatus, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { isDosageTimesInstruction } from '../Contracts/PatientMedication.Response';
import { usePermissions } from '../Hooks/usePermissions';
import { invalidDate, MedicationLocale, requiredField } from '../Medications.en';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { durationLessThanOneYear, performedDate } from '../MedicationSummary/MedicationSummaryDuration';
import { routeForDetails } from '../Routes';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { convertValidationResultToErrorsObjectV2, getFirstErrorMessageFromApiError, isDomainValidationError } from '../Shared/DomainValidationFunctions';
import { renderItemToMenuKey, renderItemToString } from '../Shared/MedicationSharedMethods';
import { errorText } from '../Styles/Colours';
import styles from './EditMedication.module.css';
import { convertContractToForm, convertFormToAdjustContract, convertFormToContract } from './EditMedicationConvertForm';
import { EditMedicationAuthorisation } from './FieldSection/EditMedicationAuthorisation';
import { EditMedicationDetailsFields } from './FieldSection/EditMedicationDetailsFields';
import { EditMedicationDosageInstructionsSection } from './FieldSection/EditMedicationDosageInstructionsSection';
import { EditMedicationHistoryDisplay } from './FieldSection/EditMedicationHistoryDisplay';
import { EditMedicationInfoHeader } from './FieldSection/EditMedicationInfoHeader';
import { EditMedicationPaymentDetails, doesPaymentSchemeNeedApprovalNumber } from './FieldSection/EditMedicationPaymentDetails';
import { EditMedicationProblemsAndViewingRights } from './FieldSection/EditMedicationProblemsAndViewingRights';
import { EditMedicationSection, EditMedicationSectionContainer } from './FieldSection/EditMedicationSection';
import { EditMedicationSupplementalDetailsSection } from './FieldSection/EditMedicationSupplementalDetailsSection';
import { EditMedicationTitle } from './FieldSection/EditMedicationTitle';
import { dosageTimesInstructionSchema, strictDosageTimesInstructionSchema } from './InstructionForm/EditDosageTimesInstructionForm';
import { freeTextInstructionSchema, strictTextInstructionSchema } from './InstructionForm/EditFreeTextInstructionsForm';
import { isDaaInstruction, useEditDosageInstructionState } from './InstructionForm/useEditDosageInstructionState';
import { EditMedicationAlertBanner } from './MedicationAlertBanner/EditMedicationAlertBanner';
import { EditSupportiveMedicationDocumentation } from './EditSupportiveMedicationDocumentation';
import { daaInstructionSchema } from './InstructionForm/EditDaaInstructionForm';
import { EditClinicalDecisionSupportAlertFloating } from './MedicationAlertBanner/EditClinicalDecisionSupportAlertFloating';
var disallowedVTOTypes = [MedicationType.MedicationHistory, MedicationType.ComplementaryTherapyOrder];
var isNotADMedicationType = function (type) {
    return type !== MedicationType.EnrmcScript && type !== MedicationType.ComplementaryTherapyOrder;
};
var isMedicationType = function (targetType) { return function (type) {
    if (!type)
        return false;
    if (typeof targetType === 'function')
        return targetType(type.value);
    return type.value === targetType;
}; };
function getInstructionValidationSchema(value, isDosageInstruction, adjustMedication) {
    if (isDosageTimesInstruction(value)) {
        return yup
            .object()
            .when('medicationType', {
            is: isMedicationType(MedicationType.EnrmcScript),
            then: strictDosageTimesInstructionSchema(true, adjustMedication)
        })
            .when('medicationType', {
            is: isMedicationType(MedicationType.ComplementaryTherapyOrder),
            then: strictDosageTimesInstructionSchema(false, adjustMedication)
        })
            .when('medicationType', {
            is: isMedicationType(isNotADMedicationType),
            then: dosageTimesInstructionSchema
        });
    }
    else {
        return yup
            .object()
            .when(['medicationType', 'dosageInstructionSameAsOrder'], {
            is: function (medicationType, dosageInstructionSameAsOrder) {
                return (isMedicationType(MedicationType.EnrmcScript)(medicationType) && !dosageInstructionSameAsOrder);
            },
            then: strictTextInstructionSchema(true)
        })
            .when(['medicationType', 'dosageInstructionSameAsOrder'], {
            is: function (medicationType, dosageInstructionSameAsOrder) {
                return (isMedicationType(MedicationType.ComplementaryTherapyOrder)(medicationType) &&
                    !dosageInstructionSameAsOrder);
            },
            then: strictTextInstructionSchema(false)
        })
            .when('medicationType', {
            is: isMedicationType(isNotADMedicationType),
            then: freeTextInstructionSchema
        })
            .when('dosageInstructionSameAsOrder', {
            is: true,
            then: freeTextInstructionSchema
        })
            .when('medicationType', {
            is: function (medicationType) {
                var dosageInstructionsOnTakeHomeScript = isMedicationType(MedicationType.TakeHomeScript)(medicationType) && isDosageInstruction;
                var orderInstructionsOnMedOrder = isMedicationType(MedicationType.MedicationOrder)(medicationType) && !isDosageInstruction;
                return dosageInstructionsOnTakeHomeScript || orderInstructionsOnMedOrder;
            },
            then: strictTextInstructionSchema(false)
        });
    }
}
var editMedicationSchema = yup.object({
    authoringSystem: yup.string(),
    authoringSystemForeignKey: yup.string(),
    updatedOn: yup.string(),
    updatedBy: yup.string(),
    name: yup.string(),
    notes: yup.string(),
    medication: yup.object().nullable(),
    medicationType: yup.object(),
    medicationCourse: yup.mixed().test({
        name: 'Course must be selected',
        message: 'Please make a selection',
        test: function (value) {
            return value !== MedicationCourse.None;
        }
    }),
    numberOfPacks: yup.string().when('medicationType', {
        is: function (value) {
            return (value.value === MedicationType.TakeHomeScript ||
                value.value === MedicationType.EnrmcScript ||
                value.value === MedicationType.ComplementaryTherapyOrder);
        },
        then: yup.string().test({
            name: 'Must be greater than 0',
            message: 'Must be greater than 0',
            test: function (value) {
                return !isNaN(Number(value)) && Number(value) > 0;
            }
        })
    }),
    repeats: yup.string().when('medicationType', {
        is: function (value) { return value.value === MedicationType.TakeHomeScript; },
        then: yup.string().test({
            name: 'Must be 0 or greater',
            message: 'Must be 0 or greater',
            test: function (value) {
                if (value == null || value == '')
                    return false;
                return !isNaN(Number(value)) && Number(value) >= 0;
            }
        })
    }),
    maximumSupplyPermitted: yup.string().when('medicationType', {
        is: function (value) {
            return value.value === MedicationType.EnrmcScript;
        },
        then: yup.string().test({
            name: 'Must be blank or a number greater than 0',
            message: 'Must be blank or a number greater than 0',
            test: function (value) {
                if (value === null || value === '' || value === undefined)
                    return true;
                return Number(value) > 0 && Number(value) <= 999999;
            }
        })
    }),
    isFreeTextMedication: yup.boolean(),
    supplyAllRepeatsAtOnce: yup.boolean(),
    scriptRetainedByPharmacy: yup.boolean(),
    minimumDaysBetweenRepeats: yup
        .string()
        .nullable()
        .test({
        name: 'MinimumDaysBetweenRepeatsRequiredForS4OrS8TakeHomeScript',
        message: 'Must be provided for S4 or S8 prescription',
        test: function (value) {
            var poisonSchedule = get(this.parent, 'medication.poisonSchedule');
            var medicationType = get(this.parent, 'medicationType');
            if (medicationType.value === MedicationType.TakeHomeScript &&
                ((poisonSchedule === null || poisonSchedule === void 0 ? void 0 : poisonSchedule.poisonScheduleStatus) === PoisonScheduleStatus.Warning ||
                    (poisonSchedule === null || poisonSchedule === void 0 ? void 0 : poisonSchedule.poisonScheduleStatus) === PoisonScheduleStatus.Alert)) {
                return !!value;
            }
            return true;
        }
    })
        .test({
        name: 'Valid repeat interval',
        message: 'Must be less than 365 days',
        test: function (value) {
            var interval = value ? Number(value) : 0;
            return interval < 366;
        }
    }),
    patientConsentsToActiveScriptList: yup.boolean(),
    patientConsentsToMyHrUpload: yup.boolean(),
    expiresOn: yup
        .string()
        .required(requiredField)
        .when('medicationType', {
        is: function (_a) {
            var value = _a.value;
            return value === MedicationType.MedicationHistory;
        },
        then: yup.string().test({
            name: 'Valid expiry date',
            message: invalidDate,
            test: function (value) {
                var performedOn = get(this.parent, 'performedOn');
                var performedOnMoment = moment(performedOn, ValidDateFormats.Edit);
                if (!!performedOn && performedOnMoment.isValid() && !!value) {
                    return moment(value, ValidDateFormats.Edit).isSameOrAfter(performedOnMoment, 'day');
                }
                return true;
            }
        }),
        otherwise: yup
            .string()
            .test({
            name: 'Valid expiry date',
            message: 'Date must be after today',
            test: function (value) {
                if (!value)
                    return false;
                var valueMoment = moment(value, ValidDateFormats.Edit);
                if (!(valueMoment === null || valueMoment === void 0 ? void 0 : valueMoment.isValid()))
                    return false;
                return valueMoment.isSameOrAfter(moment(), 'day');
            }
        })
            .test({
            name: 'Valid expiry date',
            message: 'Until date must be after Starts on date',
            test: function (value) {
                console.log(value, "value");
                var startOnDate = get(this.parent, 'orderInstruction.startsOn');
                if (startOnDate && value) {
                    var expiresOnMoment = moment(value, ValidDateFormats.Edit);
                    var startOnMoment = moment(startOnDate);
                    if (expiresOnMoment.isBefore(startOnMoment, 'day')) {
                        return this.createError({
                            message: 'Until date must be after Starts on date',
                        });
                    }
                }
                return true;
            }
        })
            .test({
            name: 'Valid expiry duration',
            message: 'Duration too long',
            test: function (value) {
                var performedOn = get(this.parent, 'performedOn');
                var performedOnMoment = moment(performedOn, ValidDateFormats.Edit);
                if (!!performedOn && performedOnMoment.isValid() && !!value) {
                    return durationLessThanOneYear(moment(value, ValidDateFormats.Edit).endOf('day'), performedDate(performedOnMoment.endOf('day').format(ValidDateFormats.IsoFormat), ValidDateFormats.IsoFormat));
                }
                return true;
            }
        })
    }),
    medicationExpiry: yup.object().required(),
    pharmacyRequestId: yup.string().nullable(),
    performedOn: yup
        .string()
        .transform(function (v) { return (v === null ? '' : v); })
        .required('DD/MM/YYYY')
        .matches(/^\d{1,2}\/\d{1,2}\/\d{4}$/, 'DD/MM/YYYY')
        .test({
        name: 'RecordedDateToday',
        message: 'Recorded date must be today',
        test: function (value) {
            var todaysDate = moment().format(ValidDateFormats.Edit);
            return value === todaysDate;
        }
    }),
    clinicalIndicationType: yup.mixed().nullable(),
    codedClinicalIndication: yup
        .object()
        .nullable()
        .test({
        name: 'ClinicalIndicationRequired',
        message: 'Reason to prescribe must be provided',
        test: function (value) {
            var medicationType = get(this.parent, 'medicationType.value');
            if ((medicationType === MedicationType.EnrmcScript || medicationType === MedicationType.ComplementaryTherapyOrder)) {
                return !!value;
            }
            return true;
        }
    }),
    freeTextClinicalIndication: yup.string().nullable(),
    viewingRight: yup.object().nullable(),
    problems: yup.array(yup.object()),
    isVerbalOrder: yup.boolean(),
    authorisingPrescriber: yup
        .object()
        .nullable()
        .test({
        name: 'Authorising prescriber is required',
        message: 'Authorising prescriber is required',
        test: function (value) {
            var isVerbalOrder = get(this.parent, 'isVerbalOrder');
            var isFreeTextMedication = get(this.parent, 'isFreeTextMedication');
            var medicationType = get(this.parent, 'medicationType.value');
            if (isVerbalOrder &&
                medicationType != null &&
                !disallowedVTOTypes.includes(medicationType) &&
                !isFreeTextMedication) {
                return !!value;
            }
            return true;
        }
    }),
    witnessOneType: yup.mixed().nullable(),
    witnessOneProvider: yup
        .object()
        .nullable()
        .test({
        name: 'Witness is required',
        message: 'Witness is required',
        test: function (value) {
            var isVerbalOrder = get(this.parent, 'isVerbalOrder');
            var isFreeTextMedication = get(this.parent, 'isFreeTextMedication');
            var medicationType = get(this.parent, 'medicationType.value');
            if (isVerbalOrder &&
                medicationType != null &&
                !disallowedVTOTypes.includes(medicationType) &&
                !isFreeTextMedication) {
                return !!value;
            }
            return true;
        }
    }),
    witnessOneName: yup.string().nullable(),
    witnessOneContactDetails: yup.string().nullable(),
    allowBrandSubstitution: yup.boolean(),
    paymentDetailAuthorityNumber: yup.string(),
    paymentDetailApprovalNumber: yup.string().test({
        name: 'Approval number is required',
        message: requiredField,
        test: function (value) {
            var medicationType = get(this.parent, 'medicationType.value');
            if (medicationType === MedicationType.EnrmcScript || medicationType === MedicationType.TakeHomeScript) {
                var snapshot = get(this.parent, 'snapshot');
                var scheme = get(this.parent, 'scheme');
                if (snapshot && scheme !== PaymentSchemeType.Private) {
                    var numberOfPacks = get(this.parent, 'numberOfPacks');
                    var repeats = get(this.parent, 'repeats');
                    var needApprovalNumber = doesPaymentSchemeNeedApprovalNumber(medicationType, snapshot.restrictionType, isNaN(Number(numberOfPacks)) ? 0 : Number(numberOfPacks), snapshot.maxNumberOfPacks, isNaN(Number(repeats)) ? 0 : Number(repeats), snapshot.maxNumberOfRepeats);
                    if (needApprovalNumber)
                        return !!value;
                }
            }
            return true;
        }
    }),
    paymentDetailReturnToPatient: yup.boolean(),
    paymentDetailPreviousAuthority: yup.boolean(),
    snapshot: yup.object().nullable(),
    scheme: yup.mixed().nullable(),
    isNonStandardPackSize: yup.boolean(),
    nonStandardPackSize: yup.string().when('isNonStandardPackSize', {
        is: function (value) { return value === true; },
        then: yup.string().test({
            name: 'Must be greater than 0',
            message: 'Must be greater than 0',
            test: function (value) {
                return !isNaN(Number(value)) && Number(value) > 0;
            }
        })
    }),
    jurisdictionalControlledSubstanceReference: yup.string().nullable(),
    nominatedDispensingPharmacy: yup.string().nullable(),
    isUrgentSupplyScriptOwing: yup.boolean(),
    isPsychotropicMedication: yup.boolean(),
    consentDetailsDescription: yup.string()
        .test({
        name: 'consentDetailsDescriptionRequired',
        message: 'Additional notes concerning consent must be provided',
        test: function (value) {
            var isPsychotropicMedication = get(this.parent, 'isPsychotropicMedication');
            if (isPsychotropicMedication) {
                return !!value;
            }
            return true;
        }
    }),
    consentDetailsStatus: yup.mixed()
        .test({
        name: 'ConsentDetailStatusRequired',
        message: 'Please make a selection',
        test: function (value) {
            var isPsychotropicMedication = get(this.parent, 'isPsychotropicMedication');
            if (isPsychotropicMedication) {
                return value !== ConsentDetailStatus.NotSet;
            }
            return true;
        }
    }),
    dosageInstructionSameAsOrder: yup.boolean(),
    dosageInstruction: yup.lazy(function (value) {
        if (isDaaInstruction(value)) {
            return daaInstructionSchema;
        }
        else {
            // Type narrowing doesn't appear to let typescript see that this should be working.
            // Ideally typescript will understand that value couldn't be a DAA at this point.
            return getInstructionValidationSchema(value, true, false);
        }
    }),
    orderInstruction: yup.lazy(function (value) {
        return getInstructionValidationSchema(value, false, false);
    }),
    isAutoRemove: yup.boolean()
});
var adjustMedicationSchema = yup.object({
    authoringSystem: yup.string(),
    authoringSystemForeignKey: yup.string(),
    updatedOn: yup.string(),
    updatedBy: yup.string(),
    name: yup.string(),
    notes: yup.string(),
    medication: yup.object().nullable(),
    medicationType: yup.object(),
    medicationCourse: yup.mixed(),
    numberOfPacks: yup.string(),
    repeats: yup.string(),
    maximumSupplyPermitted: yup.string(),
    isFreeTextMedication: yup.boolean(),
    supplyAllRepeatsAtOnce: yup.boolean(),
    scriptRetainedByPharmacy: yup.boolean(),
    minimumDaysBetweenRepeats: yup.string().nullable(),
    patientConsentsToActiveScriptList: yup.boolean(),
    patientConsentsToMyHrUpload: yup.boolean(),
    expiresOn: yup.string(),
    medicationExpiry: yup.object(),
    pharmacyRequestId: yup.string().nullable(),
    performedOn: yup.string(),
    isPsychotropicMedication: yup.boolean(),
    clinicalIndicationType: yup.mixed().nullable(),
    codedClinicalIndication: yup
        .object()
        .nullable()
        .test({
        name: 'ClinicalIndicationRequired',
        message: 'Reason to prescribe must be provided',
        test: function (value) {
            var medicationType = get(this.parent, 'medicationType.value');
            if ((medicationType === MedicationType.EnrmcScript || medicationType === MedicationType.ComplementaryTherapyOrder)) {
                return !!value;
            }
            return true;
        }
    }),
    freeTextClinicalIndication: yup.string().nullable(),
    viewingRight: yup.object().nullable(),
    problems: yup.array(yup.object()),
    isVerbalOrder: yup.boolean(),
    authorisingPrescriber: yup.object().nullable(),
    witnessOneType: yup.mixed().nullable(),
    witnessOneProvider: yup.object().nullable(),
    witnessOneName: yup.string().nullable(),
    witnessOneContactDetails: yup.string().nullable(),
    allowBrandSubstitution: yup.boolean(),
    paymentDetailAuthorityNumber: yup.string(),
    paymentDetailApprovalNumber: yup.string(),
    paymentDetailReturnToPatient: yup.boolean(),
    paymentDetailPreviousAuthority: yup.boolean(),
    snapshot: yup.object().nullable(),
    scheme: yup.mixed().nullable(),
    isNonStandardPackSize: yup.boolean(),
    nonStandardPackSize: yup.string(),
    jurisdictionalControlledSubstanceReference: yup.string().nullable(),
    nominatedDispensingPharmacy: yup.string().nullable(),
    isUrgentSupplyScriptOwing: yup.boolean(),
    consentDetailsDescription: yup.string()
        .test({
        name: 'consentDetailsDescriptionRequired',
        message: 'Additional notes concerning consent must be provided',
        test: function (value) {
            var isPsychotropicMedication = get(this.parent, 'isPsychotropicMedication');
            if (isPsychotropicMedication) {
                return !!value;
            }
            return true;
        }
    }),
    consentDetailsStatus: yup.mixed()
        .test({
        name: 'ConsentDetailStatusRequired',
        message: 'Please make a selection',
        test: function (value) {
            return value !== ConsentDetailStatus.NotSet;
        }
    }),
    dosageInstructionSameAsOrder: yup.boolean(),
    dosageInstruction: yup.lazy(function (value) {
        if (isDaaInstruction(value)) {
            return daaInstructionSchema;
        }
        else {
            // Type narrowing doesn't appear to let typescript see that this should be working.
            // Ideally typescript will understand that value couldn't be a DAA at this point.
            return getInstructionValidationSchema(value, true, true);
        }
    }),
    orderInstruction: yup.lazy(function (value) {
        return getInstructionValidationSchema(value, false, true);
    }),
    isAutoRemove: yup.boolean()
});
var MedicationTypeField = function (props) {
    // ComplementaryTherapyOrder is a valid type, but should not be an option in the medication type selection drop down menu.
    var validMedicationTypes = [];
    var permissions = usePermissions({
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsMedicationHistory: MedicationsPermissions.PrescribeMedicationsMedicationHistory
    });
    if (permissions.prescribeMedicationsTakeHomeScript) {
        validMedicationTypes.push({ value: MedicationType.TakeHomeScript });
    }
    if (permissions.prescribeMedicationsMedicationOrder) {
        validMedicationTypes.push({ value: MedicationType.MedicationOrder });
    }
    if (permissions.prescribeMedicationsMedicationHistory) {
        validMedicationTypes.push({ value: MedicationType.MedicationHistory });
    }
    if (permissions.prescribeMedicationsEnrmcScript) {
        validMedicationTypes.push({ value: MedicationType.EnrmcScript });
    }
    return (React.createElement("div", { className: styles.medicationTypeSelector },
        React.createElement(FormikStyledSelect, { readOnly: props.readOnly || props.patientMedication.isFreeTextMedication, name: 'medicationType', label: 'Medication type', maxResults: 4, itemToString: renderItemToString, itemToMenuKey: renderItemToMenuKey, customItemRender: function (suggestion) { return React.createElement("span", null, prettyPrintMedicationType(suggestion === null || suggestion === void 0 ? void 0 : suggestion.value)); }, onSelection: function (it) {
                if (isSingleSelectSingleValue(it)) {
                    props.onChangeMedicationType(it.value);
                }
            }, suggestions: validMedicationTypes, testId: 'selection-input-medication-type', hideWarningEmptyHelperText: true, isClearable: false })));
};
function hideSection(medicationType, validTypes, hide) {
    if (hide === void 0) { hide = false; }
    if (hide)
        return true;
    return !validTypes.includes(medicationType);
}
function useSectionErrors(form) {
    var generalSectionError = 'Please complete the required fields';
    var typeErrors = form.getMultipleErrorText(['authorisingPrescriber', 'witnessOneProvider']);
    var typeHasError = typeErrors.length > 0;
    var detailsErrors = form.getMultipleErrorText([
        'scheme',
        'snapshot',
        'medicationCourse',
        'medicationType',
        'medicationExpiry',
        'expiresOn',
        'allowBrandSubstitution',
        'medication',
        'isNonStandardPackSize',
        'nonStandardPackSize',
        'numberOfPacks',
        'repeats',
        'minimumDaysBetweenRepeats',
        'maximumSupplyPermitted',
        'scriptRetainedByPharmacy'
    ]);
    var detailsHasError = detailsErrors.length > 0;
    var instructionsErrors = form.getMultipleErrorText([
        'dosageInstructionSameAsOrder',
        'dosageInstruction',
        'orderInstruction'
    ]);
    var instructionsHasError = instructionsErrors.length > 0;
    var supplementalDetailsErrors = form.getMultipleErrorText([
        'notes',
        'supplyAllRepeatsAtOnce',
        'clinicalIndicationType',
        'codedClinicalIndication',
        'freeTextClinicalIndication',
        'consentDetailsStatus',
        'consentDetailsDescription',
        'jurisdictionalControlledSubstanceReference',
        'nominatedDispensingPharmacy',
        'isUrgentSupplyScriptOwing',
        'patientConsentsToActiveScriptList',
        'patientConsentsToMyHrUpload'
    ]);
    var supplementalDetailsHasError = supplementalDetailsErrors.length > 0;
    var paymentDetailsErrors = form.getMultipleErrorText([
        'paymentDetailAuthorityNumber',
        'paymentDetailApprovalNumber',
        'paymentDetailReturnToPatient',
        'paymentDetailPreviousAuthority'
    ]);
    var paymentDetailsHasError = paymentDetailsErrors.length > 0;
    var pageHasErrors = typeHasError ||
        detailsHasError ||
        instructionsHasError ||
        supplementalDetailsHasError ||
        paymentDetailsHasError;
    var typeSectionRef = useRef(null);
    var detailSectionRef = useRef(null);
    var instructionsRef = useRef(null);
    var supplementDetailsRef = useRef(null);
    var paymentDetailsRef = useRef(null);
    function navigateToErrorSection() {
        if (pageHasErrors) {
            if (typeHasError && typeSectionRef.current) {
                typeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            else if (detailsHasError && detailSectionRef.current) {
                detailSectionRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            else if (instructionsHasError && instructionsRef.current) {
                instructionsRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            else if (supplementalDetailsHasError && supplementDetailsRef.current) {
                supplementDetailsRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            else if (paymentDetailsHasError && paymentDetailsRef.current) {
                paymentDetailsRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    return {
        pageHasErrors: pageHasErrors,
        errors: {
            typeSection: typeHasError ? generalSectionError : '',
            detailsSection: detailsHasError ? generalSectionError : '',
            dosageInstructionSection: instructionsHasError ? generalSectionError : '',
            supplementalDetailsSection: supplementalDetailsHasError ? generalSectionError : '',
            paymentDetailsSection: paymentDetailsHasError ? generalSectionError : ''
        },
        refs: {
            typeSectionRef: typeSectionRef,
            detailSectionRef: detailSectionRef,
            instructionsRef: instructionsRef,
            supplementDetailsRef: supplementDetailsRef,
            paymentDetailsRef: paymentDetailsRef
        },
        navigateToErrorSection: navigateToErrorSection
    };
}
export var EditMedication = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var patientMedication = props.patientMedication;
    var editStartDate = (_a = props.patientMedication.orderInstruction) === null || _a === void 0 ? void 0 : _a.startsOn;
    var _0 = __read(useState(false), 2), showPatientMedicationHistory = _0[0], setPatientMedicationHistory = _0[1];
    var _1 = __read(useState({
        maxPacks: (_d = (_c = (_b = props.patientMedication.paymentDetails) === null || _b === void 0 ? void 0 : _b.snapshot) === null || _c === void 0 ? void 0 : _c.maxNumberOfPacks) !== null && _d !== void 0 ? _d : 0,
        maxRepeats: (_g = (_f = (_e = props.patientMedication.paymentDetails) === null || _e === void 0 ? void 0 : _e.snapshot) === null || _f === void 0 ? void 0 : _f.maxNumberOfRepeats) !== null && _g !== void 0 ? _g : 0,
        maxPerPack: (_k = (_j = (_h = props.patientMedication.paymentDetails) === null || _h === void 0 ? void 0 : _h.snapshot) === null || _j === void 0 ? void 0 : _j.maxQuantityPerPack) !== null && _k !== void 0 ? _k : 0
    }), 2), maxMedsInfo = _1[0], setMaxMedsInfo = _1[1];
    var medicationSettings = useMedicationSettings();
    var history = useHistory();
    var rootMatch = useRouteMatch();
    var handleNavigateToMedication = function (patientMedicationId) {
        history.push(routeForDetails(rootMatch.url, patientMedicationId), {
            eventId: moment().format(ValidDateFormats.DateTimeIso)
        });
    };
    var form = useForm({
        defaultValues: convertContractToForm(patientMedication),
        validationSchema: patientMedication.status === MedicationStatus.Draft
            ? editMedicationSchema
            : props.isAdjustMedication
                ? adjustMedicationSchema
                : null,
        handleSubmit: function (values, formikActions) { return __awaiter(void 0, void 0, void 0, function () {
            var err_1, errors, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!props.isAdjustMedication) return [3 /*break*/, 2];
                        return [4 /*yield*/, adjustPatientMedication(patientMedication.id, convertFormToAdjustContract(values, props.service))];
                    case 1:
                        _a.sent();
                        displayMessage('Medication adjusted.');
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, editPatientMedication(patientMedication.id, convertFormToContract(values))];
                    case 3:
                        _a.sent();
                        displayMessage('Medication updated.');
                        _a.label = 4;
                    case 4:
                        formikActions.resetForm(values);
                        props.onUpdate();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        if (patientMedication.status === MedicationStatus.Draft && !isDomainValidationError(err_1)) {
                            // Allow the rest to flow through to the 'throwError' so ErrorBoundary handles them.
                            if (props.handleErrorOnDelete)
                                props.handleErrorOnDelete(err_1);
                        }
                        else {
                            if (isDomainValidationError(err_1)) {
                                if (err_1.content) {
                                    errors = convertValidationResultToErrorsObjectV2(err_1.content, MedicationLocale);
                                    formikActions.setErrors(errors.fieldErrors);
                                }
                            }
                            errorMessage = getFirstErrorMessageFromApiError(err_1, MedicationLocale);
                            displayError(errorMessage);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); }
    });
    var dosageInstructionState = useEditDosageInstructionState({ form: form });
    var changeMedicationType = dosageInstructionState.changeMedicationType;
    var medicationType = (_m = (_l = form.values.medicationType) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : MedicationType.TakeHomeScript;
    var readOnly = patientMedication.status !== MedicationStatus.Draft;
    var showVerbalOrder = patientMedication.verbalOrderDetail != null &&
        !disallowedVTOTypes.includes(medicationType) &&
        !patientMedication.isFreeTextMedication;
    var sectionErrors = useSectionErrors(form);
    useEffect(function () {
        form.validateForm();
    }, []);
    useEffect(function () {
        editStartDate && setstartsDate(editStartDate);
    }, [editStartDate]);
    var _2 = __read(useState(''), 2), startsDate = _2[0], setstartsDate = _2[1];
    function getStartOnDate(startDate) {
        setstartsDate(startDate);
    }
    return (React.createElement(FormikProvider, { value: form.context },
        React.createElement(StyledDialogContent, { noPadding: true },
            React.createElement("div", { className: styles.container }, showPatientMedicationHistory ? (React.createElement(EditMedicationHistoryDisplay, { form: form, patientMedication: patientMedication, onClick: function () { return setPatientMedicationHistory(false); }, controlledMedicationHandler: props.controlledMedicationHandler })) : (React.createElement("div", { className: styles.container },
                React.createElement(EditMedicationInfoHeader, { updatedBy: patientMedication.updatedBy, updatedOn: patientMedication.updatedOn, onClick: function () { return setPatientMedicationHistory(true); } }),
                React.createElement("div", { className: styles.pageErrorContainer }, sectionErrors.pageHasErrors && (React.createElement("div", { className: styles.pageHasErrorDisplay, onClick: sectionErrors.navigateToErrorSection },
                    React.createElement(AlertIconRound, { color: errorText, size: '16', noPadding: true }),
                    React.createElement("span", { className: styles.errorMessage }, "Please complete the required fields below")))),
                React.createElement("div", null,
                    React.createElement(EditMedicationTitle, { form: form, patientMedication: patientMedication, readOnly: readOnly, controlledMedicationHandler: props.controlledMedicationHandler, problemsAndViewingRightsHidden: medicationSettings.settings.hideViewingRights &&
                            medicationSettings.settings.hideProblems }),
                    !(medicationSettings.settings.hideViewingRights &&
                        medicationSettings.settings.hideProblems) && (React.createElement(EditMedicationProblemsAndViewingRights, { form: form, getDefaultViewingRight: props.getDefaultViewingRight, patient: props.patient, service: props.service, patientMedication: patientMedication, hideViewingRights: medicationSettings.settings.hideViewingRights, hideProblems: medicationSettings.settings.hideProblems, readOnly: readOnly })),
                    patientMedication.decisionSupportDetail && (React.createElement(EditMedicationAlertBanner, { form: form, patientMedication: patientMedication, decisionSupportDetail: patientMedication.decisionSupportDetail, patient: props.patient, onNavigateToMedication: handleNavigateToMedication, readOnly: readOnly, controlledMedicationHandler: props.controlledMedicationHandler, showVerbalOrder: showVerbalOrder && !patientMedication.userAuthorisedToPrescribe })),
                    ((_o = patientMedication.cdsDetail) === null || _o === void 0 ? void 0 : _o.status) == CdsStatus.Noted && (React.createElement(EditClinicalDecisionSupportAlertFloating, { patientMedication: patientMedication })),
                    React.createElement("div", { className: styles.content },
                        React.createElement(EditMedicationSectionContainer, null,
                            React.createElement(EditMedicationSection, { title: 'Medication type', error: sectionErrors.errors.typeSection, ref: sectionErrors.refs.typeSectionRef, hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.MedicationOrder,
                                    MedicationType.MedicationHistory,
                                    MedicationType.EnrmcScript,
                                    MedicationType.ComplementaryTherapyOrder
                                ]), titleInput: React.createElement(MedicationTypeField, { readOnly: readOnly, patientMedication: patientMedication, onChangeMedicationType: changeMedicationType }) }, showVerbalOrder && (React.createElement(EditMedicationAuthorisation, { form: form, patientMedication: patientMedication, currentType: medicationType, readOnly: readOnly }))),
                            React.createElement(EditMedicationSection, { title: 'Medication details', error: sectionErrors.errors.detailsSection, ref: sectionErrors.refs.detailSectionRef, hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.MedicationOrder,
                                    MedicationType.MedicationHistory,
                                    MedicationType.EnrmcScript,
                                    MedicationType.ComplementaryTherapyOrder
                                ]), titleInput: patientMedication.status !== MedicationStatus.Draft ? (React.createElement("div", { className: styles.scriptNumberSelector },
                                    React.createElement(MaskedTextField, { readOnly: true, value: (_p = patientMedication.finalisedDetail) === null || _p === void 0 ? void 0 : _p.scriptNumber, label: 'Script number', testId: 'text-input-script-number', alphanumeric: true, hideWarningEmptyHelperText: true }))) : null },
                                React.createElement(EditMedicationDetailsFields, { form: form, readOnly: readOnly, maxPacks: maxMedsInfo.maxPacks, maxRepeats: maxMedsInfo.maxRepeats, medicationStatus: patientMedication.status, currentMedicationType: medicationType, poisonScheduleStatus: (_s = (_r = (_q = patientMedication.medication) === null || _q === void 0 ? void 0 : _q.poisonSchedule) === null || _r === void 0 ? void 0 : _r.poisonScheduleStatus) !== null && _s !== void 0 ? _s : null, showAllowBrandSubstitution: !!((_t = patientMedication.medication) === null || _t === void 0 ? void 0 : _t.isTradeProductPack) &&
                                        !((_u = patientMedication.medication) === null || _u === void 0 ? void 0 : _u.isOnLemi), medicationCourse: patientMedication.course, poisonScheduleCode: (_x = (_w = (_v = patientMedication.medication) === null || _v === void 0 ? void 0 : _v.poisonSchedule) === null || _w === void 0 ? void 0 : _w.code) !== null && _x !== void 0 ? _x : null, startsDate: startsDate, editStartDate: editStartDate, durationFlag: props.patientMedication.isDurationNew })),
                            React.createElement(EditMedicationDosageInstructionsSection, __assign({}, dosageInstructionState, { error: sectionErrors.errors.dosageInstructionSection, ref: sectionErrors.refs.instructionsRef, form: form, readOnly: readOnly, isAdjustMedication: props.isAdjustMedication, patient: patientMedication, currentMedicationType: medicationType, hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.MedicationOrder,
                                    MedicationType.MedicationHistory,
                                    MedicationType.EnrmcScript,
                                    MedicationType.ComplementaryTherapyOrder
                                ]), getStartOnDate: getStartOnDate })),
                            React.createElement(EditMedicationSupplementalDetailsSection, { form: form, title: 'Supplemental details', error: sectionErrors.errors.supplementalDetailsSection, ref: sectionErrors.refs.supplementDetailsRef, readOnly: readOnly, isAdjustMedication: props.isAdjustMedication, medicationStatus: patientMedication.status, patientMedication: patientMedication, currentMedicationType: medicationType, hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.MedicationOrder,
                                    MedicationType.MedicationHistory,
                                    MedicationType.EnrmcScript,
                                    MedicationType.ComplementaryTherapyOrder
                                ]) }),
                            React.createElement(EditMedicationPaymentDetails, { form: form, error: sectionErrors.errors.paymentDetailsSection, ref: sectionErrors.refs.paymentDetailsRef, readOnly: readOnly, patientMedication: patientMedication, currentProvider: props.currentProvider, onChangeMaxMedsInfo: setMaxMedsInfo, hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.EnrmcScript
                                ]) }),
                            React.createElement(EditMedicationSection, { title: 'Supporting documentation', subTitle: 'Download supporting PDF docs', hideSection: hideSection(medicationType, [
                                    MedicationType.TakeHomeScript,
                                    MedicationType.MedicationOrder,
                                    MedicationType.MedicationHistory,
                                    MedicationType.EnrmcScript
                                ], patientMedication.isFreeTextMedication ||
                                    !medicationSettings.settings.enableSupportiveDocumentation), titleInput: React.createElement(EditSupportiveMedicationDocumentation, { patientMedicationId: patientMedication.id, isTradeProductPack: (_z = (_y = patientMedication.medication) === null || _y === void 0 ? void 0 : _y.isTradeProductPack) !== null && _z !== void 0 ? _z : false }) })))))))),
        React.createElement(StyledDialogActions, null, patientMedication.status === MedicationStatus.Draft ? (React.createElement(React.Fragment, null,
            React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.redBorder, width: 161, key: 'delete', onClick: function () { return props.onDelete(); }, testId: 'edit-medication-delete' }, "Delete draft"),
            React.createElement(StyledDialogButton, { key: 'save', width: 161, testId: 'edit-medication-save', onClick: function () { return form.submitForm(); } }, "Save as draft"))) : props.isAdjustMedication ? (React.createElement(React.Fragment, null,
            React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'cancel', onClick: props.onCancel, testId: 'edit-medication-cancel' }, "Cancel"),
            React.createElement(StyledDialogButton, { key: 'save', width: 161, testId: 'edit-medication-save', onClick: function () { return form.submitForm(); } }, "Save changes"))) : (React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, width: 161, key: 'close', onClick: props.onCancel, testId: 'edit-medication-close' }, "Close")))));
};
